// Which sections of the Area detail page are shown. The panel toggles them and the body
// reads them, so the shape and its default live here rather than in either.

export type SectionKey =
  'details' | 'purpose' | 'map' | 'crossSection' | 'wells';

export type SectionVisibility = Record<SectionKey, boolean>;

/** The sections, in the order the panel lists them. */
export const SECTIONS: ReadonlyArray<{ key: SectionKey; label: string }> = [
  { key: 'details', label: 'Area Details' },
  { key: 'purpose', label: 'Purpose' },
  { key: 'map', label: 'Map' },
  // Story 7: the Cross-Section tool on this map.
  { key: 'crossSection', label: 'Cross Section' },
  // Map Query's dataset tabs, scoped to the area; the key predates the rename.
  { key: 'wells', label: 'Area Scoped Datasets' },
];

/** Everything on, as the page opens. */
export const DEFAULT_SECTION_VISIBILITY: SectionVisibility = {
  details: true,
  purpose: true,
  map: true,
  // UAT: on as the page opens, on a preset line. The box reads from the tool after.
  crossSection: true,
  wells: true,
};
